//ACITONCOPYRIGHT.SET_ACTIVITY_CONTENT
import { merge, get, set } from 'lodash';
import { ACTIONBASEINFO, ACITONCOPYRIGHT } from '../../../actionTypes';
let initState = {
	showLogin: false
};
export function CopyrightAuthReducers(state = initState, action) {
	switch (action.type) {
		case ACITONCOPYRIGHT.COPYRIGHT_AUTH_STATUS: {
			let payload = get(action, 'payload', []);
			console.log('auth.......', payload);
			state.showLogin = payload.showLogin;
			return merge({}, state, {});
		}
		default:
			return state;
	}
}
